import { render, staticRenderFns } from "./CurtainBushAppeal.vue?vue&type=template&id=01adfa61&scoped=true"
import script from "./CurtainBushAppeal.vue?vue&type=script&lang=js"
export * from "./CurtainBushAppeal.vue?vue&type=script&lang=js"
import style0 from "./CurtainBushAppeal.vue?vue&type=style&index=0&id=01adfa61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01adfa61",
  null
  
)

export default component.exports